import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "data-item" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__nav" };
const _hoisted_4 = { class: "data-item__topic" };
const _hoisted_5 = { class: "data-item__title" };
const _hoisted_6 = { class: "data-item__meta" };
const _hoisted_7 = { class: "data-item__facts" };
const _hoisted_8 = { class: "data-item__actions" };
const _hoisted_9 = { class: "data-item__content" };
const _hoisted_10 = { class: "data-item__section" };
const _hoisted_11 = { class: "receipt__delivery" };
const _hoisted_12 = { class: "receipt__actions" };
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
import trans from "@astina/paloma-common-ui/src/services/Translator";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import vensoRepository from "@/services/VensoRepository";
import VensoDelivery from "@/components/VensoDelivery.vue";
import SaveVensoDeliveryReceipt from "@/commands/SaveVensoDeliveryReceipt";
import DownloadControlDocument from "@/commands/DownloadControlDocument";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoDeliveryView',
    emits: [
        'close',
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const router = useRouter();
        const emit = __emit;
        const orderId = computed(() => Number(route.params.id));
        const order = ref(null);
        const delivery = computed(createDeliveryData);
        const update = ref(prepareReceiptUpdate());
        const saveReceipt = computed(createSaveReceiptCommand);
        const downloadControlDocument = computed(createDownloadControlDocument);
        onMounted(loadOrder);
        watch(orderId, loadOrder);
        function loadOrder() {
            vensoRepository.getOrder(orderId.value)
                .then(data => order.value = data)
                .catch(() => {
                alerts.warning(trans('venso_order.not_found'));
                router.push({ name: 'deliveries' });
            });
        }
        function onUpdateReceivedQuantity(item, qty) {
            const receiptItem = update.value.items.find(update => update.position === item.position);
            if (receiptItem) {
                receiptItem.receivedQuantity = qty;
            }
            else {
                update.value.items.push({ position: item.position, receivedQuantity: qty });
            }
        }
        function onDeliveryReceiptSaved(receipt) {
            order.value.deliveryReceipt = receipt;
        }
        function onCommentUpdate(comment) {
            update.value.comment = comment;
        }
        function onImageUpdate(imageUrls) {
            if (order.value?.deliveryReceipt) {
                order.value.deliveryReceipt.deliveryImageUris = imageUrls;
            }
        }
        function prepareReceiptUpdate() {
            if (!order.value) {
                return { items: [] };
            }
            const items = order.value.deliveryNotice?.items.map(item => ({ position: item.position, receivedQuantity: item.quantity })) || [];
            return {
                comment: order.value.deliveryReceipt?.comment,
                items,
            };
        }
        function createSaveReceiptCommand() {
            if (!order.value) {
                return undefined;
            }
            return new SaveVensoDeliveryReceipt(order.value.id, update.value);
        }
        function createDownloadControlDocument() {
            if (!order.value) {
                return undefined;
            }
            return new DownloadControlDocument(order.value.id, order.value.orderNumber);
        }
        function createDeliveryData() {
            if (!order.value) {
                return undefined;
            }
            const items = [];
            // collect order items
            order.value.items.forEach(orderItem => {
                items.push({
                    article: orderItem.article,
                    description: orderItem.article.internalProductName,
                    orderedQuantity: orderItem.quantity,
                    position: orderItem.position,
                    unitPrice: orderItem.unitPrice,
                    positionTotal: orderItem.positionTotal,
                });
            });
            // collect delivery items
            if (order.value.deliveryNotice) {
                order.value.deliveryNotice.items.forEach(noticeItem => {
                    const item = items.find(i => i.position === noticeItem.position);
                    if (item) {
                        item.notifiedQuantity = noticeItem.quantity;
                        item.position = noticeItem.position;
                    }
                    else {
                        items.push({
                            description: noticeItem.description,
                            notifiedQuantity: noticeItem.quantity,
                            position: noticeItem.position,
                            unitPrice: noticeItem.unitPrice,
                            positionTotal: noticeItem.positionTotal,
                        });
                    }
                });
            }
            // collect receipt items
            if (order.value.deliveryReceipt) {
                order.value.deliveryReceipt.items.forEach(receiptItem => {
                    const item = items.find(i => i.position === receiptItem.position);
                    if (item) {
                        item.receivedQuantity = receiptItem.receivedQuantity;
                    }
                });
            }
            return {
                id: order.value.id,
                deliveryNotice: order.value.deliveryNotice,
                items: items,
                comment: order.value.deliveryReceipt?.comment,
                deliveryImageUris: order.value.deliveryReceipt?.deliveryImageUris ?? [],
            };
        }
        function closeView() {
            emit('close');
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "angle-left" })
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (closeView()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "times" })
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "angle-right" })
                        ])
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createVNode(Spinner, {
                        loading: !order.value
                    }, null, 8, ["loading"]),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    (order.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(order.value.orderNumber), 1),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$date(order.value.deliveryDate)), 1),
                            _cache[11] || (_cache[11] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(Fact, {
                                        label: _ctx.$t('venso_supplier'),
                                        value: order.value.supplier.name,
                                        variant: "info"
                                    }, null, 8, ["label", "value"]),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    _createVNode(Fact, {
                                        label: _ctx.$t('venso_order.status'),
                                        value: _ctx.$t('VensoOrderStatus.' + order.value.status),
                                        variant: order.value.deliveryNotice ? 'success' : 'warning'
                                    }, null, 8, ["label", "value", "variant"]),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    _createVNode(Fact, {
                                        label: _ctx.$t('venso_order.confirmed'),
                                        value: order.value.deliveryReceipt ? order.value.deliveryReceipt.metadata.actor : _ctx.$t('venso_order.not_yet_received'),
                                        variant: order.value.deliveryReceipt ? 'success' : 'default'
                                    }, null, 8, ["label", "value", "variant"]),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    (order.value.deliveryReceipt)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 0,
                                            label: _ctx.$t('venso_order.confirmed_at'),
                                            value: order.value.deliveryReceipt.metadata.timestamp,
                                            "data-type": "datetime",
                                            variant: "info"
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[9] || (_cache[9] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_8, [
                                    (downloadControlDocument.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 0,
                                            command: downloadControlDocument.value,
                                            onSuccess: onDeliveryReceiptSaved,
                                            classes: ['button', 'button--outline']
                                        }, null, 8, ["command"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            (delivery.value)
                                ? (_openBlock(), _createBlock(VensoDelivery, {
                                    key: 0,
                                    delivery: delivery.value,
                                    onUpdateReceivedQuantity: _cache[3] || (_cache[3] = (item, qty) => onUpdateReceivedQuantity(item, qty)),
                                    onUpdateComment: onCommentUpdate,
                                    onUpdateImage: onImageUpdate
                                }, null, 8, ["delivery"]))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[14] || (_cache[14] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_12, [
                            (saveReceipt.value)
                                ? (_openBlock(), _createBlock(CommandButton, {
                                    key: 0,
                                    command: saveReceipt.value,
                                    onSuccess: onDeliveryReceiptSaved
                                }, null, 8, ["command"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
